import { CampaignType_Enum, SendTestMessageRequest } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { SchemaBulkMessagingService } from './service';

const getLocationHeader = (locationId?: string) =>
  locationId ? { headers: { 'Location-Id': locationId } } : undefined;

type TestEmailProps = {
  orgId: string;
  to: string;
  subject: string;
  body: string;
  attachmentMediaIds?: string[];
  locationId?: string;
};

export const sendTestEmail = ({ orgId, to, subject, body, attachmentMediaIds, locationId }: TestEmailProps) => {
  const email: SendTestMessageRequest = {
    orgId,
    destination: to,
    subject,
    messageTemplate: body,
    attachmentMediaIds,
    type: CampaignType_Enum.EMAIL,
  };
  return SchemaBulkMessagingService.SendTestMessage(email, getLocationHeader(locationId));
};

type TestMessageProps = { orgId: string; to: string; message: string; locationId?: string };

export const sendTestMessage = ({ orgId, message: messageTemplate, to, locationId }: TestMessageProps) => {
  const message: SendTestMessageRequest = {
    orgId,
    destination: to,
    messageTemplate,
    type: CampaignType_Enum.SMS,
  };
  return SchemaBulkMessagingService.SendTestMessage(message, getLocationHeader(locationId));
};
